module.exports = __webpack_public_path__ + "static/media/tennis-pre-match.667bd023.pdf";